import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=2ed014ee&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed014ee",
  null
  
)

export default component.exports